import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";

export const KitDialog = ({ kit, items, onClose, onSaved }) => {
  const api = useApi();
  const [f, setF] = useState({ name: "", description: "", items: [] });
  useEffect(() => {
    if (kit) setF({ name: kit.name || "", description: kit.description || "", items: kit.items ? kit.items.map((x) => ({ ...x })) : [] });
  }, [kit]);
  const setRow = (i, patch) => setF({ ...f, items: f.items.map((r, j) => (j === i ? { ...r, ...patch } : r)) });
  const save = async () => {
    const rows = f.items.filter((r) => r.item_id && +r.qty > 0).map((r) => ({ item_id: r.item_id, qty: +r.qty }));
    if (!f.name.trim() || !rows.length) return toast.error("Inserisci nome e almeno un articolo");
    try {
      const body = { name: f.name, description: f.description, items: rows };
      if (kit.id) await api.put(`/kits/${kit.id}`, body); else await api.post("/kits", body);
      toast.success("Kit salvato");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!kit} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-slate-900 border-slate-700 max-w-xl max-h-[90vh] overflow-y-auto" data-testid="kit-dialog">
        <DialogHeader><DialogTitle>{kit?.id ? "Modifica pacchetto" : "Nuovo pacchetto"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5"><Label className="micro-label">Nome pacchetto</Label><Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="kit-name-input" /></div>
          <div className="space-y-1.5"><Label className="micro-label">Descrizione</Label><Input value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="kit-description-input" /></div>
          <div className="space-y-2">
            <Label className="micro-label">Articoli</Label>
            {f.items.map((r, i) => (
              <div key={i} className="flex gap-2" data-testid={`kit-row-${i}`}>
                <Input type="number" min={1} value={r.qty} onChange={(e) => setRow(i, { qty: e.target.value })} className="w-20 font-mono" data-testid={`kit-row-qty-${i}`} />
                <Select value={r.item_id} onValueChange={(v) => setRow(i, { item_id: v })}>
                  <SelectTrigger className="flex-1 min-w-0" data-testid={`kit-row-item-${i}`}><SelectValue placeholder="Scegli articolo" /></SelectTrigger>
                  <SelectContent>{items.map((it) => <SelectItem key={it.id} value={it.id}>{it.category} · {it.name}</SelectItem>)}</SelectContent>
                </Select>
                <Button size="icon" variant="ghost" onClick={() => setF({ ...f, items: f.items.filter((_, j) => j !== i) })}><X className="h-4 w-4" /></Button>
              </div>
            ))}
            <Button variant="outline" size="sm" onClick={() => setF({ ...f, items: [...f.items, { item_id: "", qty: 1 }] })} data-testid="kit-add-row-btn"><Plus className="h-4 w-4 mr-1" />Aggiungi articolo</Button>
          </div>
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Annulla</Button><Button onClick={save} data-testid="kit-save-btn">Salva pacchetto</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
